import { Translations } from '@/types/types';
import { ApiQueryKey } from '@/configs/ApiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'tiles',
	COLOR = 'color',
	INPUT = 'input',
	THINNING = 'thinning',
}

export interface Attribute extends BaseEntity {
	name: string;
	suffix: string;
	description: string;
	viewType: AttributeViewType;
	listOrder: number;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(ApiQueryKey.attributes);
	}
}

export default new AttributeApi();
